var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{on:{"reload_active_tab":_vm.reload_active_tab}})}
var staticRenderFns = []

export { render, staticRenderFns }